import { render } from "./HostDetail.vue?vue&type=template&id=4a9e3e2d"
import script from "./HostDetail.vue?vue&type=script&lang=js"
export * from "./HostDetail.vue?vue&type=script&lang=js"

import "./HostDetail.vue?vue&type=style&index=0&id=4a9e3e2d&lang=css"
script.render = render

export default script